import React, { useCallback, useState, useEffect } from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import moment from 'moment';
import { Steps } from 'antd';
import srv from '../../../../services';
import { ContentWrapper, DownloadButton } from '../../../_common';
import {
 StapletIcon,
 ZoomInIcon,
 ZoomOutIcon,
 RegisteredIcon,
 ProccesingIcon,
 InWorkedIcon,
 ClosedIcon,
 CreatedIcon,
 AnswerIcon,
 QuestionIcon,
} from '../../../_assests';
import {
 Empty,
 Content,
 Appeal,
 AppealData,
 AppealParam,
 AppealContent,
 AppealZoom,
 Messages,
 Message,
 MessageHead,
 MessageDate,
 MessageText,
 MessageFiles,
 ContractZoom,
 TitleStep,
 StepBlockDis,
 StepBlockDone,
 ShowButton,
 TopicName,
} from './Appeals.styled';
import { Checkbox } from '@material-ui/core';
import SnackBar from '../../../Shared/SnackBar';
import { AppealsOfficialColumns } from '../../../Shared/columns/AppealsOfficialColumns';
import { AppealsOfficialDetailsColumns } from '../../../Shared/columns/AppealsOfficialDetailsColumns';
import AppealOfficialModel from '../../../Shared/models/AppealOfficialModel';
import DataGrid from '../../../Shared/DataGrid/DataGrid';
import { RootState } from '../../../../store/store';
import { shallowEqual, useSelector } from 'react-redux';
import {
 Box,
 Button,
 TextField,
 Alert,
 Snackbar,
 MenuItem,
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ruLocale from 'dayjs/locale/ru';
import dayjs, { Dayjs } from 'dayjs';
import { makeStyles } from '@material-ui/core/styles';
const { Step } = Steps;

const useStyles = makeStyles({
 docType: {
  width: '380px',
  marginLeft: '-26px !Important',
  '& .MuiInputBase-root': {
   height: '32px !Important',
   fontSize: '12px !Important',
  },
  '& .MuiSelect-select': {
   fontSize: '12px !Important',
  },
  '& .MuiInputLabel-root': {
   fontSize: '12px',
   transform: 'translate(14px, 8px) scale(1)',
  },
  '& .MuiInputLabel-shrink': {
   transform: 'translate(14px, -6px) scale(0.75)',
  },
  '& .MuiFormHelperText-root': {
   fontSize: '10px',
  },
 },
 menuItem: {
  fontSize: '12px !Important',
  paddingY: '6px !Important',
 },
 email: {
  width: '260px',
  marginLeft: '-6px !Important',
  '& .MuiInputBase-root': {
   height: '32px',
   fontSize: '13px',
  },
  '& .MuiSelect-select': {
   fontSize: '13px',
  },
  '& .MuiInputLabel-root': {
   fontSize: '13px',
   transform: 'translate(14px, 8px) scale(1)',
  },
  '& .MuiInputLabel-shrink': {
   transform: 'translate(14px, -6px) scale(0.75)',
  },
  '& .MuiFormHelperText-root': {
   fontSize: '10px',
  },
 },
 datePicker: {
  width: '380px',
  '& .MuiInputBase-root': {
   height: '32px',
   fontSize: '13px',
  },
  '& .MuiSelect-select': {
   fontSize: '13px',
  },
  '& .MuiInputLabel-root': {
   fontSize: '13px',
   transform: 'translate(14px, 8px) scale(1)',
  },
  '& .MuiInputLabel-shrink': {
   transform: 'translate(14px, -6px) scale(0.75)',
  },
  '& .MuiFormHelperText-root': {
   fontSize: '10px',
  },
 },
});

export default function Appeals() {
 const {
  appeals,
  isLoading,
  error,
  maximized,
  onMaximize,
  handleDateFromChange,
  handleDateToChange,
  showData,
  setShowData,
  dateFrom,
  dateTo,
  filterData,
  setDateFrom,
  setDateTo,
 } = useAppeals();
 const [currentStep, setCurrentStep] = useState(null);
 const [showGrid, setShowGrid] = useState(false);
 const [appealOfficialData, setAppealOfficialData] = useState<
  AppealOfficialModel[]
 >([]);
 const [mainColumns, setMainColumns] = useState(AppealsOfficialColumns());
 const [detailColumns, setDetailColumns] = useState(
  AppealsOfficialDetailsColumns(),
 );

 const classes = useStyles();

 const [limitDays, setLimitDays] = useState(1);
 const [isError, setIsError] = useState(false);
 const [successMessage, setSuccessMessage] = useState(
  'Нажмите кнопку Показать для отображения данных за период не более 1 года.',
 );
 const [errorMessage, setErrorMessage] = useState(
  'Период запроса не может быть более 1 года, дата заменена.',
 );
 const [message, setMessage] = useState(
  'Нажмите кнопку Показать для отображения данных за период не более 1 года.',
 );
 const [buttonVisible, setButtonVisible] = useState<boolean>(true);
 const [errors, setErrors] = useState<{ [key: string]: string }>({});

 const configData = useSelector(
  (state: RootState) => state.config,
  shallowEqual,
 );

 useEffect(() => {
  const appealsOfficialColumns = AppealsOfficialColumns();
  const detailColumns = AppealsOfficialDetailsColumns();

  setMainColumns(appealsOfficialColumns);
  setDetailColumns(detailColumns);

  srv.getShowFeedbackTableView().then((response) => {
   if (response && response.data) {
    setShowGrid(response.data === '0' ? false : true);
   }
  });
 }, []);

 useEffect(() => {
  srv.getShowFeedbackTableView().then((response) => {
   if (response && response.data) {
    setShowGrid(response.data === '0' ? false : true);
   }
  });
 }, [showGrid]);

 useEffect(() => {
  let appealArray: AppealOfficialModel[] = [];

  appeals.forEach((item: any) => {
   const create = item.eventsHystory.filter((x) => x.eventName === 'Создано');
   const inPreparation = item.eventsHystory.filter(
    (x) => x.eventName === 'В обработке',
   );
   const registration = item.eventsHystory.filter(
    (x) => x.eventName === 'Зарегистрировано',
   );
   const inProcess = item.eventsHystory.filter(
    (x) => x.eventName === 'Принято в работу',
   );
   const closed = item.eventsHystory.filter((x) => x.eventName === 'Закрыто');

   const appeal: AppealOfficialModel = {
    requestNumber: item.requestNumber,
    questionMessage: item.message,
    questionCreateDate: item.createDate,
    responseMessage: item.responseMessage,
    responseDate: item.responseDate,

    id: item.id,

    responseCreate:
     create && create.length > 0 && create[0].eventName
      ? create[0].eventName
      : '',
    responseCreateDate:
     create && create.length > 0 && create[0].createDate
      ? create[0].createDate
      : '',

    responseInPreparation:
     inPreparation && inPreparation.length > 0 && inPreparation[0].eventName
      ? inPreparation[0].eventName
      : '',
    responseInPreparationDate:
     inPreparation && inPreparation.length > 0 && inPreparation[0].createDate
      ? inPreparation[0].createDate
      : '',

    responseRegistration:
     registration && registration.length > 0 && registration[0].eventName
      ? registration[0].eventName
      : '',
    responseRegistrationDate:
     registration && registration.length > 0 && registration[0].createDate
      ? registration[0].createDate
      : '',

    responseInProcess:
     inProcess && inProcess.length > 0 && inProcess[0].eventName
      ? inProcess[0].eventName
      : '',
    responseInProcessDate:
     inProcess && inProcess.length > 0 && inProcess[0].createDate
      ? inProcess[0].createDate
      : '',

    responseClosed:
     closed && closed.length > 0 && closed[0].eventName
      ? closed[0].eventName
      : '',
    responseClosedDate:
     closed && closed.length > 0 && closed[0].createDate
      ? closed[0].createDate
      : '',

    attachedFiles: item?.attachedFiles ? item?.attachedFiles : null,
   };

   appealArray.push(appeal);

   item.eventsHystory.forEach((event, idx) => {
    if (event.createDate !== null) setCurrentStep(idx);
   });
  });

  setAppealOfficialData(appealArray);
 }, [appeals]);

 const showGridChangeHandle = (value: React.ChangeEvent<HTMLInputElement>) => {
  const payload = {
   newValue: `${Number(value?.target?.checked)}`,
  };

  srv.setShowFeedbackTableView(payload).then(() => {
   setShowGrid(!showGrid);
  });
 };

 return (
  <ContentWrapper isLoading={isLoading} error={error}>
   <Content>
    <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
     {showGrid && (
      <DataGrid
       columns={mainColumns?.columns ? mainColumns.columns : []}
       detailColumns={detailColumns?.columns ? detailColumns.columns : []}
       rows={appeals}
       detailsRows={appealOfficialData}
       detailsType={'appealOfficial'}
       take={20}
       page={1}
       pagination={true}
       rowHeight={100}
       isShowPaging={'no'}
      />
     )}
    </div>

    <Box
     sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      justifyItems: 'center',
      alignContent: 'center',
     }}
    >
     <Box
      sx={{
       display: 'flex',
       flexDirection: 'row',
       alignItems: 'flex-start',
       justifyContent: 'flex-start',
       justifyItems: 'center',
       alignContent: 'center',

       gap: 1,
       width: '700px',
      }}
     >
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={ruLocale}>
       <DatePicker
        label="Начало периода"
        maxDate={dayjs()}
        inputFormat="DD.MM.YYYY"
        value={dateFrom}
        //onChange={(newValue) => handleDateFromChange(newValue)}
        onChange={() => {}}
        onAccept={(newValue) => {
         handleDateFromChange(newValue);
         if (dateTo && newValue) {
          const limit = newValue.add(limitDays, 'year') as any;
          if (dateTo.valueOf() > limit.valueOf()) {
           setDateTo(limit);
           setMessage(errorMessage);
           setIsError(true);
          } else {
           setMessage(successMessage);
           setIsError(false);
          }
         }
        }}
        renderInput={(params) => (
         <TextField
          {...params}
          size="small"
          error={!!errors.range}
          helperText={errors.range}
          fullWidth
          className={classes.datePicker}
          sx={{ width: '600px !important' }}
         />
        )}
       />
      </LocalizationProvider>

      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={ruLocale}>
       <DatePicker
        label="Окончание периода"
        maxDate={dayjs()}
        inputFormat="DD.MM.YYYY"
        value={dateTo}
        onChange={() => {}}
        onAccept={(newValue) => {
         handleDateToChange(newValue);
         if (dateFrom && newValue) {
          const limit = newValue.add(-limitDays, 'year') as any;
          if (dateFrom.valueOf() < limit.valueOf()) {
           setDateFrom(limit);
           setMessage(errorMessage);
           setIsError(true);
          } else {
           setMessage(successMessage);
           setIsError(false);
          }
         }
        }}
        renderInput={(params) => (
         <TextField
          {...params}
          error={!!errors.range}
          fullWidth
          size="small"
          className={classes.datePicker}
          sx={{ width: '600px !important' }}
         />
        )}
       />
      </LocalizationProvider>

      {buttonVisible && (
       <ShowButton size="small" variant="contained" onClick={filterData}>
        Показать
       </ShowButton>
      )}
     </Box>

     {/* <div style={{ marginBottom: '20px', marginTop: '-10px' }}>
       <label
        style={{
         marginRight: '5px',
         top: '20px !important',
         color: 'black',
         fontWeight: 600,
        }}
       >
        Показать в табличном виде
       </label>
       <Checkbox
        checked={showGrid}
        style={{
         height: '40px',
         width: '40px',
         color: '#ffb614',
        }}
        onChange={showGridChangeHandle}
       />
      </div> */}

     {showData && appeals && appeals?.length > 0 ? (
      <div
       style={{
        marginTop: '10px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        justifyItems: 'flex-start',
        marginLeft: '-10px',
        width: '100%',
        flexWrap: 'wrap',
       }}
      >
       {appeals.map((appeal) => {
        const date = appeal.eventsHystory.map((item) => {
         return item.createDate;
        });
        const status = appeal.eventsHystory.map((item) => {
         return item.eventState;
        });
        return (
         <Appeal
          key={appeal.id}
          featured={appeal.isNew}
          maximized={maximized === appeal.id}
         >
          <ContractZoom onClick={() => onMaximize(appeal)}>
           {maximized === appeal.id ? <ZoomOutIcon /> : <ZoomInIcon />}
          </ContractZoom>
          <AppealData onClick={() => onMaximize(appeal)}>
           <AppealParam cols>
            <span>
             <u>№ обращения</u>
             {appeal.regNumber ? <b>{appeal.regNumber}</b> : 'На регистрации'}
            </span>

            <span>
             <u>Обращение</u>
             Официальное
            </span>
           </AppealParam>

           <TopicName>
            <u>Тема</u>
            <b>{appeal.topicName}</b>
           </TopicName>

           <AppealParam>
            <u>№ договора</u>
            <b>{appeal.contractNumber}</b>
           </AppealParam>

           <AppealParam cols>
            <span>
             <u>Дата создания</u>
             {moment(appeal.createDate).format('DD.MM.YYYY')}
            </span>
            <span>
             <u>Срок ответа</u>
             {appeal.responseTime === null
              ? undefined
              : moment(appeal.responseTime).format('DD.MM.YYYY')}
            </span>
           </AppealParam>

           {maximized === appeal.id && (
            <>
             <AppealParam>
              <u>Услуга</u>
              {appeal.serviceName}
             </AppealParam>

             <AppealParam>
              <u>Представительство</u>
              {appeal.territoryName}
             </AppealParam>

             <AppealParam>
              <u>Способ получения ответа</u>
              {appeal.answerDeliveryName}
             </AppealParam>

             <AppealParam>
              <u>Ответственный за предоставление ответа</u>
              <span>{appeal.addressee}</span>
             </AppealParam>
            </>
           )}

           <AppealParam cols={appeal.isNew}>
            <span>
             <u>Статус</u>
             {appeal.state}
            </span>

            {appeal.isNew && (
             <span>
              <u>Новое сообщение</u>
              <strong>{configData.companyShortName}</strong>
             </span>
            )}
           </AppealParam>
          </AppealData>

          {maximized === appeal.id && (
           <AppealContent>
            <Messages>
             <Message>
              <MessageHead>
               <MessageDate>
                Вы {moment(appeal.createDate).format('DD.MM.YYYY')}
               </MessageDate>
               <QuestionIcon />
              </MessageHead>
              <MessageText>{appeal.message}</MessageText>

              {!!appeal.attachedFiles?.length && (
               <MessageFiles>
                {appeal.attachedFiles.map((file) => (
                 <DownloadButton
                  key={file.id}
                  url={`/feedback/download/${file.id}`}
                  fileName={file.fileName}
                  icon={<StapletIcon />}
                 >
                  {file.fileName}
                 </DownloadButton>
                ))}
               </MessageFiles>
              )}
             </Message>

             {!!appeal?.answer && (
              <Message answer>
               <MessageHead>
                <AnswerIcon />
                <MessageDate>
                 АО «ЭК «Восток»{' '}
                 {moment(appeal.answer.createDate || undefined).format(
                  'DD.MM.YYYY',
                 )}
                </MessageDate>
               </MessageHead>

               {!!appeal.answer.message && (
                <MessageText>{appeal.answer.message}</MessageText>
               )}

               {!!appeal.answer.attachedFiles?.length && (
                <MessageFiles>
                 {appeal.answer.attachedFiles.map((file) => (
                  <DownloadButton
                   key={file.id}
                   url={`/feedback/download/${file.id}`}
                   fileName={file.fileName}
                   icon={<StapletIcon />}
                  >
                   {file.fileName}
                  </DownloadButton>
                 ))}
                </MessageFiles>
               )}
              </Message>
             )}
            </Messages>
            <Steps current={currentStep}>
             <Step
              status={status[0] === 'Выполняется' ? 'finish' : 'wait'}
              title={
               <TitleStep>
                <span>Создано</span>
                {moment(appeal.createDate).format('DD.MM.YYYY')}
               </TitleStep>
              }
              icon={
               status[0] === 'Выполняется' ? (
                <CreatedIcon />
               ) : (
                <StepBlockDone>
                 <CreatedIcon />
                </StepBlockDone>
               )
              }
             />
             <Step
              status={status[1] === 'Выполняется' ? 'finish' : 'wait'}
              title={
               <TitleStep>
                <span>В обработке</span>
                {date[1] !== null
                 ? moment(date[1]).format('DD.MM.YYYY')
                 : undefined}
               </TitleStep>
              }
              icon={
               status[1] === 'Выполняется' ? (
                <ProccesingIcon />
               ) : status[1] === 'В ожидании' ? (
                <StepBlockDis>
                 <ProccesingIcon />
                </StepBlockDis>
               ) : (
                <StepBlockDone>
                 <ProccesingIcon />
                </StepBlockDone>
               )
              }
             />
             <Step
              status={status[2] === 'Выполняется' ? 'finish' : 'wait'}
              title={
               <TitleStep>
                <span>Зарегистрировано</span>
                {date[2] !== null
                 ? moment(date[2]).format('DD.MM.YYYY')
                 : undefined}
               </TitleStep>
              }
              icon={
               status[2] === 'Выполняется' ? (
                <RegisteredIcon />
               ) : status[2] === 'В ожидании' ? (
                <StepBlockDis>
                 <RegisteredIcon />
                </StepBlockDis>
               ) : (
                <StepBlockDone>
                 <RegisteredIcon />
                </StepBlockDone>
               )
              }
             />
             <Step
              status={status[3] === 'Выполняется' ? 'finish' : 'wait'}
              title={
               <TitleStep>
                <span>В работе</span>
                {date[3] !== null
                 ? moment(date[3]).format('DD.MM.YYYY')
                 : undefined}
               </TitleStep>
              }
              icon={
               status[3] === 'Выполняется' ? (
                <InWorkedIcon />
               ) : status[3] === 'В ожидании' ? (
                <StepBlockDis>
                 <InWorkedIcon />
                </StepBlockDis>
               ) : (
                <StepBlockDone>
                 <InWorkedIcon />
                </StepBlockDone>
               )
              }
             />
             <Step
              status={status[4] === 'Выполняется' ? 'finish' : 'wait'}
              title={
               <TitleStep>
                <span>Закрыто</span>
                {date[4] !== null
                 ? moment(date[4]).format('DD.MM.YYYY')
                 : undefined}
               </TitleStep>
              }
              icon={
               status[4] === 'Выполняется' ? (
                <ClosedIcon />
               ) : status[4] === 'В ожидании' ? (
                <StepBlockDis>
                 <ClosedIcon />
                </StepBlockDis>
               ) : (
                <StepBlockDone>
                 <ClosedIcon />
                </StepBlockDone>
               )
              }
             />
            </Steps>
           </AppealContent>
          )}

          <AppealZoom onClick={() => onMaximize(appeal)} />
         </Appeal>
        );
       })}
      </div>
     ) : (
      <Empty>
       <label style={{ color: isError ? '#EB7F31' : 'gray' }}>{message}</label>
      </Empty>
     )}
    </Box>
   </Content>
  </ContentWrapper>
 );
}

function useAppeals() {
 const queryClient = useQueryClient();

 const [maximized, setMaximized] = useState(null);
 const [showData, setShowData] = useState(false);
 const [dateFrom, setDateFrom] = useState(moment().subtract(1, 'months'));
 const [dateTo, setDateTo] = useState(new Date());

 const contragentData = useSelector(
  (state: RootState) => state.getContragent,
  shallowEqual,
 );

 const {
  data: appeals,
  isFetching,
  error,
  refetch,
 } = useQuery<Models.Appeal[]>({
  queryKey: ['appeals', { dateFrom, dateTo }],
  queryFn: () =>
   srv.getAppeals(
    contragentData,
    dateFrom.format('YYYY-MM-DD'),
    moment((dateTo as any).$d).format('YYYY-MM-DD'),
   ),
  //queryFn: () => srv.getAppeals(),
  initialData: [],
  enabled: false,
 });

 const { mutate: markRead } = useMutation(
  (id: number) => srv.markRead('officialAppeals', id),
  {
   onSuccess: () => {
    queryClient.refetchQueries('feature');
    queryClient.refetchQueries('appeals');
   },
  },
 );

 //  useEffect(() => {
 //   setShowData(true);
 //   refetch().then(() => {
 //    setShowData(true);
 //   });
 //  }, []);

 useEffect(() => {
  setShowData(false);
 }, [contragentData]);

 const handleDateFromChange = (value: any) => {
  setDateFrom(value);
  setShowData(false);
 };

 const handleDateToChange = (value: any) => {
  setDateTo(value);
  setShowData(false);
 };

 const filterData = () => {
  refetch().then((response: any) => {
   setShowData(true);
  });
 };

 const onMaximize = useCallback(
  (appeal: Models.Appeal) => {
   if (appeal.isNew) {
    markRead(appeal.id);
   }

   if (maximized === appeal.id) {
    setMaximized(null);
   } else {
    setMaximized(appeal.id);
   }
  },
  [markRead, maximized],
 );

 return {
  appeals,
  isLoading: isFetching && !appeals?.length,
  error,
  maximized,
  onMaximize,
  handleDateFromChange,
  handleDateToChange,
  showData,
  setShowData,
  dateFrom,
  dateTo,
  filterData,
  setDateFrom,
  setDateTo,
 };
}
